import { normalizeToStartOfDayUTC } from '@/utils/date-formatters';

import { TimeOffRequestDayDto } from '../types/dto/time-off-request-day.dto';
import { DayPortion } from '../types/time-off-request';
import { TimeOffRequestFormValues } from '../validations/time-off-request-form.schema';

/** Maps one working day's form values to the request payload day DTO. */
export const mapTimeOffFormDayToDto = (
  day: TimeOffRequestFormValues['days'][number]
): TimeOffRequestDayDto => {
  const base: TimeOffRequestDayDto = {
    date: normalizeToStartOfDayUTC(new Date(day.date)).toISOString(),
    portion: day.portion,
  };

  if (day.portion === DayPortion.Half || day.portion === DayPortion.Quarter) {
    base.dayPartNumber = Number(day.dayPartNumber);
  }
  if (day.portion === DayPortion.Hourly) {
    base.minutes = day.minutes ?? 0;
  }

  return base;
};

export const mapTimeOffWorkingDaysToDto = (
  days: TimeOffRequestFormValues['days']
): TimeOffRequestDayDto[] => days.filter(day => day.isWorkingDay).map(mapTimeOffFormDayToDto);
